<template>
  <div v-if="product" class="product-details">
    <div class="product-details__section product-details__left">
      <ProductDetailsDescription
        class="product-details__section__inner product-details__description"
        :description="product.description"
      />
      <ProductDetailsInfo
        class="product-details__section__inner product-details__info"
        :product="product"
      />
      <ProductDetailsFeatures
        class="product-details__features"
        :features="features"
      />
    </div>
    <div class="product-details__right">
      <ProductDetailsServices
        class="product-details__section product-details__services"
      />
      <ProductDetailsDimensions
        class="product-details__section product-details__dimensions"
        :product="product"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';
import { useWindow } from '~/composables';
import ProductDetailsDescription from './ProductDetailsDescription.vue';
import ProductDetailsInfo from './ProductDetailsInfo.vue';
import ProductDetailsFeatures from './ProductDetailsFeatures.vue';
import ProductDetailsServices from './ProductDetailsServices.vue';
import ProductDetailsDimensions from './ProductDetailsDimensions.vue';

export default defineComponent({
  name: 'ProductDetails',
  components: {
    ProductDetailsDescription,
    ProductDetailsInfo,
    ProductDetailsFeatures,
    ProductDetailsServices,
    ProductDetailsDimensions,
  },
  props: {
    product: {
      type: Object,
      default: () => null,
    },
    features: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const { isDesktop } = useWindow();
    return { isDesktop };
  },
});
</script>

<style lang="scss" scoped>
.product-details {
  &__section {
    border-top: var(--general-border);
    padding: 2.5rem 1.25rem;
    &__inner {
      padding-bottom: 2.5rem;
    }
  }
  @include from-desktop-min {
    display: flex;
    width: 100%;
    &__section {
      padding: 0;
    }
    &__left {
      width: 50%;
      border-right: var(--general-border);
    }
    &__right {
      width: 50%;
    }
    &__description {
      padding: 6.25rem 2.5rem 2.5rem 7.5rem;
    }
    &__info {
      padding: 0 2.5rem 5rem 7.5rem;
    }
    &__features {
      padding: 0 2.5rem 6.25rem 7.5rem;
    }
    &__services {
      padding: 3.75rem 5rem 5rem;
    }
    &__dimensions {
      padding: 3.75rem 5rem 5rem;
    }
  }
}
</style>
